import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, MapPin, Phone, Mail, Facebook, Twitter, Instagram, Youtube } from 'lucide-react';

const toHindiDigits = (str) => str.replace(/[0-9]/g, d => '०१२३४५६७८९'[d]);

const Footer = () => {
  // Address and phone with line breaks
  const address = [
    toHindiDigits('8, योगेश्वरी अपार्टमेंट, तीसरी मंजिल, आय.डी.बी.आई. बैंक के उपर, गुळवणी महाराज पथ, एरंडवणे, पुणे 411004, महाराष्ट्र, भारत')];
  const phones = [
    { display: toHindiDigits('+91 9423014414'), href: 'tel:+919423014414' },
    { display: toHindiDigits('+91 9422034483'), href: 'tel:+919422034483' },
    { display: toHindiDigits('+91 9730624909'), href: 'tel:+919730624909' }
  ];
  const email = { display: 'sanjayswadeshi6@gmail.com', href: 'mailto:sanjayswadeshi6@gmail.com' };

  return (
    <footer className="bg-gradient-to-tr from-gray-900 via-gray-950 to-gray-900 text-white border-t border-gray-800">
      <div className="container mx-auto px-4 py-6 flex flex-col md:flex-row md:justify-between md:items-center gap-8">
        {/* Left: Logo & About */}
        <div className="flex-1 flex flex-col items-center md:items-start text-center md:text-left gap-4">
          <div className="flex items-center gap-4 mb-2">
  <img
    src="/images/sidhisochlogo.png" // <-- Replace with your actual image path
    alt="सीधी सोच सीधी बात Logo"
    className="h-14 w-auto object-contain"
  />
  <span className="font-extrabold text-1xl md:text-1xl text-orange-500 tracking-wide drop-shadow">

  जयहिंद, जय श्रीराम!
  </span>
</div>

          <p className="text-gray-300 mb-2 max-w-md text-base md:text-lg font-medium">
            समाज सेवा, शिक्षा, स्वास्थ्य, न्याय और सामाजिक सुधार के लिए समर्पित व्यक्तिगत मंच।
          </p>
          <p className="text-orange-500 mb-2 max-w-md text-base md:text-lg font-medium">
          देश है तो धर्म है, और धर्म है तो हम सब सुरक्षित हैं। 
          {/* जयहिंद, जय श्रीराम! */}
          </p>
          <div className="flex gap-5 mt-2">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-orange-500 transition-colors">
              <Facebook className="w-6 h-6" />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-orange-500 transition-colors">
              <Twitter className="w-6 h-6" />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-orange-500 transition-colors">
              <Instagram className="w-6 h-6" />
            </a>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-orange-500 transition-colors">
              <Youtube className="w-6 h-6" />
              </a>
            </div>
          </div>

        {/* Divider for desktop */}
        <div className="hidden md:block h-32 w-px bg-gradient-to-b from-orange-400/10 via-gray-700 to-orange-400/10 mx-8 rounded-full" />

        {/* Right: Contact Info - Icons left, text right, left-aligned, compact */}
        <div className="flex-1 flex flex-col items-start justify-left text-left gap-1">
          <a
            href="https://maps.google.com/?q=8, Yogeshwari Apartment, 3rd Floor, Above IDBI Bank, Gulawani Maharaj Path, Erandwane, Pune 411004, Maharashtra, India"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 group"
          >
            <span className="bg-orange-600/90 rounded-full p-2 group-hover:bg-orange-500 transition-colors"><MapPin className="w-5 h-5 text-white" /></span>
            <span className="text-gray-300 text-base md:text-lg font-medium leading-snug">
              {address.map((line, i) => (
                <React.Fragment key={i}>{line}<br /></React.Fragment>
              ))}
            </span>
          </a>
          <div
            className="flex items-center gap-3 group"
          >
            <span className="bg-orange-600/90 rounded-full p-2 group-hover:bg-orange-500 transition-colors"><Phone className="w-5 h-5 text-white" /></span>
            <span className="text-gray-300 text-base md:text-lg font-medium leading-snug">
            {phones.map((phone, i) => (
  <React.Fragment key={i}>
    <a href={phone.href} className="hover:text-orange-400 transition-colors">{phone.display}</a>
    {i < phones.length - 1 && <span className="mx-2 text-orange-400">|</span>}
  </React.Fragment>
))}

            </span>
          </div>
          <div
            className="flex items-center gap-3 group"
          >
            <span className="bg-orange-600/90 rounded-full p-2 group-hover:bg-orange-500 transition-colors"><Mail className="w-5 h-5 text-white" /></span>
            <span className="text-gray-300 text-base md:text-lg font-medium leading-snug">
              <a href={email.href} className="hover:text-orange-400 transition-colors">{email.display}</a>
            </span>
          </div>
        </div>
      </div>

      {/* Sitemap Links in Copyright Section */}
      <div className="border-t border-gray-800 py-4 mt-6">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-gray-400 text-sm text-center md:text-left">
              {new Date().getFullYear()} सीधी सोच सीधी बात. सर्व हक्क सुरक्षित.
            </div>
            
            <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-400">
              <Link to="/" className="hover:text-orange-400 transition-colors">होम</Link>
              <span className="text-gray-600">|</span>
              <Link to="/about" className="hover:text-orange-400 transition-colors">परिचय</Link>
              <span className="text-gray-600">|</span>
              <Link to="/karya" className="hover:text-orange-400 transition-colors">कार्य</Link>
              <span className="text-gray-600">|</span>
              <Link to="/rachnaye" className="hover:text-orange-400 transition-colors">रचनाएँ</Link>
              <span className="text-gray-600">|</span>
              <Link to="/blog" className="hover:text-orange-400 transition-colors">ब्लॉग</Link>
              <span className="text-gray-600">|</span>
              <Link to="/contact" className="hover:text-orange-400 transition-colors">संपर्क</Link>
              <span className="text-gray-600">|</span>
              <Link to="/sitemap" className="hover:text-orange-400 transition-colors">साईटमॅप</Link>
            </div>
            
            <div className="text-gray-500 text-sm">
              Design & Develope By <a href="https://codevergeit.com" target="_blank" rel="noopener noreferrer" className="text-orange-400 hover:underline">CodeVerge IT</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;